import React from 'react';
import PropTypes from 'prop-types';
import style from '../Debug.module.scss';

const SearchSettings = (props = {}) => {
  const { handleMinSearchLength, minSearchLength } = props;
  return (
    <div className={style.panel}>
      <div className={style.header}>Search Settings</div>
      <div className={style.formLabel}>Minimum Search Length</div>
      <div className={style.formLabel}>Override: {minSearchLength}</div>
      <div className={style.body}>
        <form onSubmit={handleMinSearchLength}>
          <div>
            <input
              type="number"
              defaultValue={minSearchLength}
              name="minSearchLength"
              id="minSearchLength"
            />
            <button type="submit">Set Minimum Search Length</button>
          </div>
        </form>
      </div>
    </div>
  );
};

SearchSettings.defaultProps = {};

SearchSettings.propTypes = {
  minSearchLength: PropTypes.number,
  handleMinSearchLength: PropTypes.func,
};

export default SearchSettings;
